import BaseListStore from 'stores/BaseListStore';
import StatStore, { IStat, IStatHistory } from 'stores/stat/StatStore';
import { SortDirection } from 'constants/SortDirection';
import { get, post } from 'stores/_services/dataService';
import { action, observable, makeObservable } from 'mobx';

const STAT_LIMIT = 7;

export default class StatListStore extends BaseListStore<StatStore> {
    currentIndex = 0;

    constructor() {
        super({
            itemStore: StatStore
        });

        makeObservable(this, {
            currentIndex: observable,
            setCurrentIndex: action
        });
    }

    get currentStats(): IStat | undefined {
        const id = this.ids[this.currentIndex];

        if (id) {
            return this.data.get(id)?.stat;
        }
    }

    get prevStats(): IStat | undefined {
        const id = this.ids[this.currentIndex + 1];

        if (id) {
            return this.data.get(id)?.stat;
        }
    }

    getHistoryForStat(field: string): IStatHistory[] {
        return this.items.map((s) => {
            return {
                count: s?.stat.data?.[field as keyof IStat['data']],
                startDate: s?.stat.fromDate,
                endDate: s?.stat.toDate
            };
        });
    }

    setCurrentIndex(index: number | string): void {
        this.currentIndex = parseInt(String(index));
    }

    async refreshDashboard(): Promise<void> {
        await post('dashboardData/refreshDashboard');
    }

    async getStats(): Promise<void> {
        const options = {
            filter: {
                where: { data: { neq: null } },
                order: `createdOn ${SortDirection.DESC}`,
                limit: STAT_LIMIT
            }
        };

        const { data } = await get('dashboardData', options);

        this._updateData(data);
        this._updateIds(data);
    }
}
